<template>
	<b-button variant="link" class="btn-back" v-on:click.once="back"><icon-base width="14" height="25"><icon-caret-right /></icon-base> Back</b-button>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconCaretRight from '../icons/IconCaretRight.vue'

export default {
  name: 'BackButton',
  props: {
    user: Object,
    lists: Object
  },
  components: {
    IconBase,
    IconCaretRight,
  },
  methods: {
    back: function () {
      this.$emit('back');
    }
  },
}
</script>

